import { makeStyles } from '@material-ui/core';
import React from 'react';

import { ReactComponent as PlexBrandingSvg } from '../../../assets/plex_branding.svg';
import { spacings } from '../../../theme';
import { SharedNavBar } from '../../shared/navigation/SharedNavBar';

export const NavBar = (): React.ReactElement => {
  const classes = useStyles();
  return (
    <SharedNavBar>
      <div className={classes.plexLogo}>
        <PlexBrandingSvg />
      </div>
    </SharedNavBar>
  );
};

const useStyles = makeStyles((theme) => ({
  plexLogo: {
    flexShrink: 0,
    width: 260,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: spacings.xlarge,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
